"use strict";
// Copyright (c) 2021 by Move Closer
Object.defineProperty(exports, "__esModule", { value: true });
exports.useViewer = exports.viewerProps = void 0;
const composition_api_1 = require("@vue/composition-api");
const uuid_1 = require("uuid");
const Container_1 = require("../Container");
/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
exports.viewerProps = {
    breakpoint: {
        type: String,
        required: false
    },
    config: {
        type: Object,
        required: false,
        default: () => ({})
    },
    containerComponent: {
        type: [Function, Object],
        required: false
    },
    containers: {
        type: Object,
        required: true
    },
    elementProps: {
        type: Object,
        required: false,
        default: () => ({})
    },
    moduleComponent: {
        type: [Function, Object],
        required: true
    },
    modules: {
        type: Object,
        required: true
    },
    nonce: {
        type: String,
        required: false,
        default: null
    },
    structure: {
        type: Object,
        required: true
    },
    useFallbackBreakpoint: {
        type: Boolean,
        required: false,
        default: true
    }
};
/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
function createDefaultViewerConfig() {
    return {
        columns: Container_1.defaultColumnsCount,
        controls: {
            addContainer: false,
            addModule: false,
            cloneContainer: false,
            cloneModule: false,
            copyContainer: false,
            copyModule: false,
            pasteIntoContainer: false,
            editContainer: false,
            editModule: false,
            removeContainer: false,
            removeModule: false
        },
        minRowHeight: true,
        showControls: false
    };
}
/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
const useViewer = (props, ctx) => {
    const { breakpoint, config, structure } = (0, composition_api_1.toRefs)(props);
    const resolvedConfig = (0, composition_api_1.computed)(() => {
        return Object.assign(Object.assign({}, createDefaultViewerConfig()), config.value);
    });
    const id = (0, composition_api_1.computed)(() => (['b', `${(0, uuid_1.v4)().split('-').pop()}`].join('-')));
    const gridTemplate = (0, composition_api_1.computed)(() => {
        if (resolvedConfig.value.columns === Container_1.defaultColumnsCount) {
            return null;
        }
        return `#${id.value} .builder__container-inner { grid-template-columns: repeat(${resolvedConfig.value.columns}, minmax(0, 1fr)); }`;
    });
    const structureToDisplay = (0, composition_api_1.computed)(() => {
        if (!Object.keys(structure.value).length) {
            ctx.emit('error', 'Viewer: There are no breakpoints defined.');
            return [];
        }
        if (!breakpoint.value ||
            (!structure.value[breakpoint.value] && props.useFallbackBreakpoint)) {
            return structure.value[Object.keys(structure.value)[0]];
        }
        return structure.value[breakpoint.value] || [];
    });
    return { gridTemplate, id, resolvedConfig, structureToDisplay };
};
exports.useViewer = useViewer;
//# sourceMappingURL=Viewer.hook.js.map